import { render } from "./index.vue?vue&type=template&id=de38a6ae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=de38a6ae&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de38a6ae"]])

export default __exports__